<template>
	<div style="padding: 10px 10px 10px 0;">
		<!-- tab切换 -->
		<el-tabs v-model="type" @tab-click="handleClick">
			<el-tab-pane label="保洁检查计划表" name="保洁检查计划表">
			</el-tab-pane>
			<el-tab-pane label="保安检查计划表" name="保安检查计划表">
			</el-tab-pane>
		</el-tabs>
		<!-- 条件查询 -->
		<el-form :inline="true" :model="selectForm" class="demo-form-inline">
			<div class="flex sb">
				<div>
					<el-form-item label="时间">
						<el-date-picker v-model="selectForm.time" type="daterange" range-separator="~"
							start-placeholder="开始日期" end-placeholder="结束日期" style="width: 280px;">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="巡检结果">
						<el-select v-model="selectForm.result" placeholder="巡检结果">
							<el-option label="正常" value="正常"></el-option>
							<el-option label="异常" value="异常"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="巡检人">
						<el-input v-model="selectForm.userName" placeholder="巡检人" style="width: 100px;"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getAll()">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="handleClear">重置</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="dc()">导出</el-button>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<!-- 表格内容 -->
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="date" label="日期">
				<template slot-scope="{row}">{{row.date?setTime(row.date):""}}</template>
			</el-table-column>
			<el-table-column prop="address" label="巡检路线"></el-table-column>
			<el-table-column prop="clockTime" label="打卡时间">
				<template slot-scope="{row}">{{row.clockTime?setTime(row.clockTime):""}}</template>
			</el-table-column>
			<el-table-column prop="result" label="巡检结果"></el-table-column>
			<el-table-column prop="username" label="责任人"></el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="selectForm.rows"
			layout="total, sizes, prev, pager, next, jumper" :total="count" @size-change="handleSizeChange"
			@current-change="handleCurrentChange">
		</el-pagination>
	</div>
</template>

<script>
	import publicExport from '../../assets/js/publicExport.js';
	export default {
		data() {
			return {
				headers: {
					Authorization: localStorage.access_token
				},
				count: 0,
				type: "保洁检查计划表",
				selectForm: {
					result: "", //结果
					username: "", //巡检人
					page: 1,
					rows: 10,
					time: "", //时间段
					startTime: "", //开始时间
					endTime: "", //结束时间
					type: ""
				},
				oldSelect: {},
				oldForm: "",
				data: []
			}
		},
		methods: {
			dc() {
				publicExport("/api/admin/export/uploadSecurityCheckResult", this.selectForm, this.type.substr(0,2)+"检查结果")
			},
			ok() { //新增或修改
				let url = "/api/check/add"
				if (this.title == "编辑") {
					url = "/api/check/update"
				}
				if (this.form.time) {
					this.form.startTime = new Date(this.form.time[0]).getTime()
					this.form.endTime = new Date(this.form.time[1]).getTime()
				} else {
					this.form.startTime = ""
					this.form.endTime = ""
				}
				let addressList = []
				if (this.form.addressList) {
					this.form.addressList.forEach(item => {
						let time = ""
						if (item.clockTime != "") {
							time = new Date(item.clockTime).getTime()
						}
						addressList.push({
							address: item.address,
							clockTime: time
						})
					})
				}
				this.form.type = "安保"
				if (this.type == "保洁检查计划表") {
					this.form.type = "保洁"
				}
				let standardTime = "";
				if (this.form.standardTime) {
					standardTime = new Date(this.form.standardTime).getTime()
				}
				this.$http.post(url, {
					...this.form,
					addressList,
					standardTime
				}).then(res => {
					if (res.data.code == 0) {
						this.getAll()
						this.show = false
						this.$message.success(`${this.title}成功`)
					} else {
						this.$message.error(`${this.title}失败`)
					}
				})
			},
			getAll() {
				this.selectForm.startTime = ""
				this.selectForm.endTime = ""
				if (this.selectForm.time) {
					this.selectForm.startTime = new Date(this.selectForm.time[0]).getTime()
					this.selectForm.endTime = new Date(this.selectForm.time[1]).getTime()
				}
				this.selectForm.type = "安保"
				if (this.type == "保洁检查计划表") {
					this.selectForm.type = "保洁"
				}
				this.$http.post("/api/checkResult/select", this.selectForm).then(res => {
					this.data = res.data.data.items
					this.count = res.data.data.totalNum
				})
			},
			handleClick() {
				this.getAll()
			},
			handleCurrentChange(val) {
				this.selectForm.page = val;
				this.getAll()
			},
			handleSizeChange(val) {
				this.selectForm.rows = val;
				this.getAll()
			},
			handleClear() {
				this.selectForm = JSON.parse(JSON.stringify(this.oldSelect))
				this.getAll()
			},
		},
		created() {
			this.oldSelect = JSON.parse(JSON.stringify(this.selectForm))
			this.getAll();
		}
	}
</script>

<style scoped="scoped">
</style>
